/*
 * Объект-помощник для работы с GET-параметрами адресной строки.
 */

const URLHelper = {
    searchParams: new URLSearchParams(window.location.search), // Получение изначальных GET-параметров
    // Добавить/изменить значение GET-параметра
    setParam(param, value) {
        this.searchParams.set(param, value);
        const url = this.searchParams.toString();
        this.setURLSearch(url);
    },
    // Получить значение GET-параметра
    getParamVal(paramName) {
        return this.searchParams.get(paramName);
    },
    // Удалить значение GET-параметра
    deleteParam(val) {
        this.searchParams.delete(val);
        const url = this.searchParams.toString();
        this.setURLSearch(url);
    },
    // Функция, изменяющая адресную строку, выполняется внутри объекта
    setURLSearch(url) {
        window.history.pushState({}, '', `?${url}`);
    },
    // Изменяет URI
    setURI(val) {
        window.history.pushState({}, '', val);
    },
    // Проверка на существование GET-параметров
    isSearchExist() {
        return !!this.searchParams.toString();
    },
    isParamExist(param) {
        return this.searchParams.has(param);
    },
    // Получить строкой все GET-параметры
    getSearchString() {
        return `?${this.searchParams.toString()}`;
    }
};

export default URLHelper;
